/* Two native Shopify posts: contact receipt first, consented customer signup second.
   Never fetch /contact or infer success from an HTTP status. Shopify owns challenges.
   The email stays in this tab for at most 30 minutes and is removed after signup. */
(function () {
  'use strict';
  var KEY = 'ow-email-consent-v1';
  var MAX_AGE = 30 * 60 * 1000;
  function clear() { try { sessionStorage.removeItem(KEY); } catch (e) {} }
  function read() {
    try {
      var value = JSON.parse(sessionStorage.getItem(KEY));
      if (!value || typeof value.email !== 'string' || !value.email ||
          !Number.isFinite(value.created) || Date.now() - value.created > MAX_AGE) {
        clear(); return null;
      }
      return value.path === location.pathname ? value : null;
    } catch (e) { clear(); return null; }
  }
  window.OmniEmailConsent = {
    prepare: function (form) {
      var checkbox = form.querySelector('[data-ow-email-optin]');
      if (!checkbox || !checkbox.checked) { clear(); return true; }
      var feedback = form.querySelector('[data-ow-email-storage]');
      var value = {
        email: form.elements['contact[email]'].value.trim(),
        formId: form.id, path: location.pathname, phase: 'contact', created: Date.now()
      };
      try {
        sessionStorage.setItem(KEY, JSON.stringify(value));
        if (!read()) throw new Error('Storage unavailable');
        feedback.textContent = '';
        return true;
      } catch (e) {
        feedback.textContent = 'Tab storage is off. Uncheck to send, then subscribe in the footer.';
        checkbox.focus();
        return false;
      }
    }
  };

  document.querySelectorAll('[data-ow-email-optin]').forEach(function (checkbox) { checkbox.disabled = false; });
  var pending = read();
  var targetId = location.hash.slice(1);
  var target = document.getElementById(targetId);
  // Shopify returns the same customer form state to every customer form on a page.
  // Only the submitted form should announce that state.
  document.querySelectorAll('[data-ow-newsletter]').forEach(function (form) {
    var active = form === target || (pending && form.id === pending.formId + '-newsletter');
    if (!active) {
      form.querySelector('[data-ow-email-status]').textContent = '';
      form.querySelector('input[type="email"]').removeAttribute('aria-invalid');
    }
    form.addEventListener('submit', function () {
      if (pending && form.id !== pending.formId + '-newsletter') clear();
    });
  });

  if (target && target.matches('[data-ow-newsletter]')) {
    var wrapper = target.closest('[data-ow-email-followup]');
    if (wrapper) wrapper.hidden = false;
    var status = target.querySelector('[data-ow-email-status]');
    if (status.textContent.trim()) status.focus();
  }
  if (!pending) return;
  var contact = document.getElementById(pending.formId);
  var signup = document.getElementById(pending.formId + '-newsletter');
  if (!contact || !signup) { clear(); return; }
  var followup = signup.closest('[data-ow-email-followup]');
  var email = signup.elements['contact[email]'];
  var message = signup.querySelector('[data-ow-email-status]');
  if (pending.phase === 'contact' && contact.querySelector('[data-ow-error]')) {
    contact.elements['contact[email]'].value = pending.email;
    contact.querySelector('[data-ow-email-optin]').checked = true;
    clear(); return;
  }
  if (pending.phase === 'customer' || contact.querySelector('[data-ow-sent]')) {
    followup.hidden = false;
    followup.querySelector('h2').textContent = 'Your request was received';
    email.value = pending.email;
    if (signup.querySelector('[data-ow-email-success]')) { clear(); return; }
    if (pending.phase === 'customer') {
      // Do not auto-retry after a challenge, server error, refresh, or back navigation.
      if (!signup.querySelector('[data-ow-email-error]')) {
        message.textContent = 'Email signup is not confirmed yet. Select Subscribe to try again.';
      }
      return;
    }
    pending.phase = 'customer';
    try { sessionStorage.setItem(KEY, JSON.stringify(pending)); }
    catch (e) { clear(); return; }
    message.textContent = 'Your request was received. Submitting your email signup.';
    // Allow Shopify's own form and challenge scripts to finish loading first.
    window.addEventListener('load', function () {
      if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) {
        window.Shopify.captcha.protect(signup, function () { signup.requestSubmit(); });
      } else {
        signup.requestSubmit();
      }
    }, { once: true });
  } else {
    // A fresh visit must not silently reuse consent from an abandoned request.
    clear();
  }
})();
